import React from "react"
import IconV2 from "../icon-v2"
import {
  StyledReviewWrapper,
  StyledReview,
  StyledDetails,
  StyledName,
  StyledRating,
  StyledStar,
} from "./partials"

export interface ReviewProps {
  review: string
  name: string
  rating: string
}

export const ReviewCmp: React.FC<ReviewProps> = ({ review, name, rating }) => {
  return (
    <StyledReviewWrapper>
      <StyledReview>{review && review}</StyledReview>
      <StyledDetails>
        <StyledName>{name && name}</StyledName>
        <StyledRating rating={rating}>
          <StyledStar>
            <IconV2 iconType="fas" icon="star" />
          </StyledStar>
          <StyledStar>
            <IconV2 iconType="fas" icon="star" />
          </StyledStar>
          <StyledStar>
            <IconV2 iconType="fas" icon="star" />
          </StyledStar>
          <StyledStar>
            <IconV2 iconType="fas" icon="star" />
          </StyledStar>
          <StyledStar>
            <IconV2 iconType="fas" icon="star" />
          </StyledStar>
        </StyledRating>
      </StyledDetails>
    </StyledReviewWrapper>
  )
}
